import {
    SET_GENERAL_TEXT,
    SET_DOWNLOAD_EVERYTHING_TEXT,
    SET_RUN_WITH_LOGS_TEXT,
    SET_RUN_WITH_DX9_TEXT,
    SET_MINIMIZE_TO_TRAY_TEXT,
    SET_LANGUAGE_TEXT,
    SET_RESET_TEXT,
    SET_FORGET_ALL_ACCOUNTS_TEXT,
    SET_FORGET_ALL_ACCOUNTS_TOOLTIP_TEXT,
    SET_SHARED_CACHE_SETTINGS_TEXT,
    // SET_RESET_TO_DEFAULTS_TEXT,
    SET_MANAGE_API_PERMISSIONS_TEXT,
    SET_TEST_SERVERS_TEXT,
    SET_LAUNCH_OPTIONS_TEXT,
    SET_AUTO_LAUNCH_ON_LOGIN_TEXT,
    SET_AUTO_LAUNCH_ON_LOGIN_TOOLTIP_TEXT,
    SET_AUTO_LAUNCH_ON_STARTUP_TEXT,
    SET_AUTO_LAUNCH_ON_STARTUP_TOOLTIP_TEXT,
    SET_LAUNCH_DELAY_TEXT,
    SET_SECONDS_TEXT,
    SET_CONFIRM_FORGET_TEXT,
    SET_SETTING_SAVED_TITLE_TEXT,
    // SET_SETTING_SAVED_MESSAGE_TEXT,
    SET_LAYOUT_TEXT,
    SET_LAYOUT_DEFAULT_TEXT,
    SET_LAYOUT_RIGHT_TEXT,
    SET_LAYOUT_LEFT_TEXT,
    SET_TEXTS,
} from './constants'

const initialState = {
    general: '',
    downloadEverything: '',
    runWithLogs: '',
    runWithDX9: '',
    minimizeToTray: '',
    language: '',
    reset: '',
    forgetAllAccounts: '',
    forgetAllAccountsTooltip: '',
    sharedCacheSettings: '',
    // resetToDefaults: '',
    manageApiPermissions: '',
    testServers: '',
    launchOptions: '',
    autoLaunchOnLogin: '',
    autoLaunchOnLoginTooltip: '',
    autoLaunchOnStartup: '',
    autoLaunchOnStartupTooltip: '',
    launchDelay: '',
    seconds: '',
    confirmForget: '',
    settingSavedTitle: '',
    // settingSavedMessage: '',
    layout: '',
    layoutDefault: '',
    layoutRight: '',
    layoutLeft: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_GENERAL_TEXT: {
            return {
                ...state,
                general: action.payload,
            }
        }

        case SET_DOWNLOAD_EVERYTHING_TEXT: {
            return {
                ...state,
                downloadEverything: action.payload,
            }
        }

        case SET_RUN_WITH_LOGS_TEXT: {
            return {
                ...state,
                runWithLogs: action.payload,
            }
        }

        case SET_RUN_WITH_DX9_TEXT: {
            return {
                ...state,
                runWithDX9: action.payload,
            }
        }

        case SET_MINIMIZE_TO_TRAY_TEXT: {
            return {
                ...state,
                minimizeToTray: action.payload,
            }
        }

        case SET_LANGUAGE_TEXT: {
            return {
                ...state,
                language: action.payload,
            }
        }

        case SET_RESET_TEXT: {
            return {
                ...state,
                reset: action.payload,
            }
        }

        case SET_FORGET_ALL_ACCOUNTS_TEXT: {
            return {
                ...state,
                forgetAllAccounts: action.payload,
            }
        }

        case SET_FORGET_ALL_ACCOUNTS_TOOLTIP_TEXT: {
            return {
                ...state,
                forgetAllAccountsTooltip: action.payload,
            }
        }

        case SET_SHARED_CACHE_SETTINGS_TEXT: {
            return {
                ...state,
                sharedCacheSettings: action.payload,
            }
        }

        // case SET_RESET_TO_DEFAULTS_TEXT: {
        //     return {
        //         ...state,
        //         resetToDefaults: action.payload,
        //     }
        // }

        case SET_MANAGE_API_PERMISSIONS_TEXT: {
            return {
                ...state,
                manageApiPermissions: action.payload,
            }
        }

        case SET_TEST_SERVERS_TEXT: {
            return {
                ...state,
                testServers: action.payload,
            }
        }

        case SET_LAUNCH_OPTIONS_TEXT: {
            return {
                ...state,
                launchOptions: action.payload,
            }
        }

        case SET_AUTO_LAUNCH_ON_LOGIN_TEXT: {
            return {
                ...state,
                autoLaunchOnLogin: action.payload,
            }
        }

        case SET_AUTO_LAUNCH_ON_LOGIN_TOOLTIP_TEXT: {
            return {
                ...state,
                autoLaunchOnLoginTooltip: action.payload,
            }
        }

        case SET_AUTO_LAUNCH_ON_STARTUP_TEXT: {
            return {
                ...state,
                autoLaunchOnStartup: action.payload,
            }
        }

        case SET_AUTO_LAUNCH_ON_STARTUP_TOOLTIP_TEXT: {
            return {
                ...state,
                autoLaunchOnStartupTooltip: action.payload,
            }
        }

        case SET_LAUNCH_DELAY_TEXT: {
            return {
                ...state,
                launchDelay: action.payload,
            }
        }

        case SET_SECONDS_TEXT: {
            return {
                ...state,
                seconds: action.payload,
            }
        }

        case SET_CONFIRM_FORGET_TEXT: {
            return {
                ...state,
                confirmForget: action.payload,
            }
        }

        case SET_SETTING_SAVED_TITLE_TEXT: {
            return {
                ...state,
                settingSavedTitle: action.payload,
            }
        }

        // case SET_SETTING_SAVED_MESSAGE_TEXT: {
        //     return {
        //         ...state,
        //         settingSavedMessage: action.payload,
        //     }
        // }

        case SET_LAYOUT_TEXT: {
            return {
                ...state,
                layout: action.payload,
            }
        }

        case SET_LAYOUT_DEFAULT_TEXT: {
            return {
                ...state,
                layoutDefault: action.payload,
            }
        }

        case SET_LAYOUT_RIGHT_TEXT: {
            return {
                ...state,
                layoutRight: action.payload,
            }
        }

        case SET_LAYOUT_LEFT_TEXT: {
            return {
                ...state,
                layoutLeft: action.payload,
            }
        }

        case SET_TEXTS: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/texts/reducer.js